import { FontWeight, Heading, HeadingVariant } from '@lili/lili-frontend-common';
import { useTranslation } from 'react-i18next';
import logoUrl from '@Assets/logos/lili-logo-blue.svg';
import { Icon, Icons } from '@Components/icon/Icon';
import { OptionStrip } from '@Components/OptionStrip';
import { useBoundStore } from '@Store/useBoundStore';
import { useNavigationManager } from '@Router/useNavigationManager';
import { useResizeListener } from '@Hooks/custom/useResizeListener';
import { RoutesMap } from '@Router/router.types';
import { ResetPasswordMfaType } from './reset-password-types';
import { MobileBackButton } from './shared/MobileBackButton';

export const RecoveryType = () => {
  const { t } = useTranslation();
  const { setRequestMfaType } = useBoundStore((state) => state.resetPasswordSlice);
  const { navigateToNextPage } = useNavigationManager();
  const { isMobile } = useResizeListener();
  const handleOptionClick = (mfaType: ResetPasswordMfaType) => {
    setRequestMfaType(mfaType);
    navigateToNextPage(RoutesMap.RECOVERY_TYPE);
  };

  return (
    <div className='recovery-page-container'>
      <MobileBackButton />
      <div className='flex flex-col pt-[56px] md:pt-[0px] w-full md:w-[520px] px-[24px] md:px-[42px] items-center'>
        <img src={logoUrl} alt='Lili Logo' className='w-[80px] mb-[32px]' />
        <Heading
          variant={isMobile ? HeadingVariant.H7 : HeadingVariant.H3}
          fontWeight={FontWeight.MEDIUM}
          className='recovery-page-header'>
          {t('recovery.recoveryType.title')}
        </Heading>
        <Heading.H10
          fontWeight={FontWeight.REGULAR}
          className='text-text-main-secondary text-center mb-[24px]'>
          {t('recovery.recoveryType.subtitle')}
        </Heading.H10>
        <div className='w-full max-w-[500px] flex flex-col gap-[18px]'>
          <OptionStrip
            icon={<Icon className='w-[38px] max-w-[38px]' icon={Icons.TextMessage} />}
            title={t('recovery.recoveryType.textMessageOption')}
            onClick={() => handleOptionClick(ResetPasswordMfaType.SMS)}
          />
          <OptionStrip
            icon={<Icon className='w-[38px] max-w-[38px]' icon={Icons.Emailtype} />}
            title={t('recovery.recoveryType.emailOption')}
            onClick={() => handleOptionClick(ResetPasswordMfaType.EMAIL)}
          />
        </div>
      </div>
    </div>
  );
};
